import { gql, TypedDocumentNode } from "@apollo/client";

import {
  RemoveUserFromTeamMutation,
  RemoveUserFromTeamMutationVariables,
} from "./RemoveUserFromTeam.generated";

const REMOVE_USER_FROM_TEAM: TypedDocumentNode<
  RemoveUserFromTeamMutation,
  RemoveUserFromTeamMutationVariables
> = gql`
  mutation removeUserFromTeam(
    $teamUuid: String!
    $userUuid: String!
  ) {
    removeUserFromTeam(teamUuid: $teamUuid, userUuid: $userUuid) {
      ok
      removedUser {
        success
        email
      }
    }
  }
`;

export default REMOVE_USER_FROM_TEAM;
